export const DIALOG_SEE_PROBLEM_QUESTIONS = 'see-problem-questions';
